import { useEffect } from "react";

const Shop = () => {
  useEffect(() => {
    // Redirect to external shop URL when component mounts
    window.location.href = "https://form.jotform.com/260228601261851";
  }, []);

  // This component will redirect before rendering, but provide fallback content
  return (
    <div className="min-h-screen bg-white flex items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-cyan-400 mx-auto mb-4"></div>
        <p className="text-gray-600">Redirecting to Football X Shop...</p>
        <p className="text-sm text-gray-400 mt-2">
          If you're not redirected automatically, 
          <a 
            href="https://form.jotform.com/260228601261851" 
            className="text-cyan-500 hover:text-cyan-300 ml-1"
          >
            click here
          </a>
        </p>
      </div>
    </div>
  );
};

export default Shop;